module.exports = __webpack_public_path__ + "img/background-banner.7b385bdc.png";